<template>
  <div class="content-body">
    <div class="top">PC端物料管理</div>
    <div class="body">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="addPlan">新建物料</el-button>
      <div class="condition">
        <div class="form">
          <div class="demo-input-suffix">
            广告主:
            <el-select v-model="form.type" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="company_name" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            链接名称:
            <el-input v-model="form.keyword" placeholder="" style="width: 160px; margin-left: 10px;" size="small"></el-input>
          </div>
          <el-button type="primary" @click="search" size="small">查询</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" border style="width: 1371px" size="small" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
          <el-table-column label="物料名称" prop="material_name" align="center" />
          <el-table-column label="花费金额" prop="click_target_link" align="center">
            <template slot-scope="scope">
              {{ scope.row.pay_money }}
            </template>
          </el-table-column>
          <el-table-column label="缩略图" prop="login_link" align="center">
            <template slot-scope="scope">
              <el-image v-if="scope.row.adv_type !== 8" style="width: 80px; height: 80px; margin: 0 10px 10px 0;" :src="scope.row.pic" :preview-src-list="[scope.row.pic]"></el-image>
              <video v-else
                     v-bind:src="scope.row.video_path"
                     class="avatar video-avatar"
                     controls="controls"
                     style="margin-top: 10px; width: 120px">
                  您的浏览器不支持视频播放
              </video>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="show_link" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_audit === 1 ? 'success' : scope.row.is_audit === 0 ? 'warning' : 'danger'">{{ scope.row.is_audit === 1 ? "审核通过" : scope.row.is_audit === 0 ? "审核中" : "审核不通过" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="物料类型" prop="show_link" align="center">
            <template slot-scope="scope">
              {{ getAdvType(scope.row.adv_type) }}
            </template>
          </el-table-column>
          <el-table-column label="定向运营商/联网类型" prop="show_link" align="center" width="160">
            <template slot-scope="scope">
              {{ getNetwork(scope.row).carrier }} / {{ getNetwork(scope.row).network }}
            </template>
          </el-table-column>
          <el-table-column label="曝光次数" prop="show_link" align="center">
            <template slot-scope="scope">
              {{ scope.row.read_num }}
            </template>
          </el-table-column>
          <el-table-column label="点击次数" prop="show_link" align="center">
            <template slot-scope="scope">
              {{ scope.row.look_num }}
            </template>
          </el-table-column>
          <el-table-column label="点击率" prop="show_link" align="center">
            <template slot-scope="scope">
              {{ scope.row.click_l }}
            </template>
          </el-table-column>
          <el-table-column label="更新日期" prop="show_link" align="center">
            <template slot-scope="scope">
              {{ scope.row.update_date }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editOne(scope.$index)">编辑</el-button>
              <el-button type="text" style="color: red;" size="mini" @click="delOne(scope.row.material_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-c">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="新建物料"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%">
      <el-form ref="form" label-width="120px" label-position="left">
        <el-form-item label="账户资质">
          <el-input v-model="company_name" placeholder="" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="联网渠道" class="is-required">
          <el-select v-model="saveData.network" placeholder="请选择">
            <el-option label="不限" value="0"></el-option>
            <el-option label="2G" value="1"></el-option>
            <el-option label="3G" value="2"></el-option>
            <el-option label="4G" value="3"></el-option>
            <el-option label="5G" value="4"></el-option>
            <el-option label="WIFI" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营商" class="is-required">
          <el-select v-model="saveData.carrier" placeholder="请选择">
            <el-option label="不限" value="0"></el-option>
            <el-option label="中国移动" value="1"></el-option>
            <el-option label="中国联通" value="2"></el-option>
            <el-option label="中国电信" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告类型">
          <el-radio v-model="saveData.adv_type" label="1">小图</el-radio>
          <el-radio v-model="saveData.adv_type" label="2">大图</el-radio>
          <el-radio v-model="saveData.adv_type" label="3">组图</el-radio>
          <el-radio v-model="saveData.adv_type" label="4">横幅</el-radio>
          <el-radio v-model="saveData.adv_type" label="5">插屏</el-radio>
          <el-radio v-model="saveData.adv_type" label="6">开屏</el-radio>
          <el-radio v-model="saveData.adv_type" label="7">视频暂停位</el-radio>
          <el-radio v-model="saveData.adv_type" label="8">视频广告位</el-radio>
        </el-form-item>
        <el-form-item label="物料名称" class="is-required">
          <el-input v-model="saveData.material_name" placeholder="物料名称"></el-input>
        </el-form-item>
        <el-form-item label="广告推广语" class="is-required">
          <el-input v-model="saveData.material_desc" placeholder="广告推广语"></el-input>
        </el-form-item>
        <el-form-item label="链接类型">
          <el-radio v-model="saveData.link_type" label="1">链接</el-radio>
          <el-radio v-model="saveData.link_type" label="2">APK</el-radio>
        </el-form-item>
        <el-form-item label="选择推广链接" v-if="saveData.link_type === '1'">
          <el-select v-model="saveData.link_id">
            <el-option label="请选择" :value="0"></el-option>
            <el-option :label="item.link_name" :value="item.link_id" v-for="(item, index) in linkData" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="apk下载链接" v-if="saveData.link_type === '2'">
          <el-input v-model="saveData.down_link" placeholder="https://"></el-input>
        </el-form-item>
        <el-form-item label="上传视频" required v-show="saveData.adv_type === '8'">
          <el-upload class="avatar-uploader"
            :action="getLink()"
            v-bind:on-progress="uploadVideoProcess"
            v-bind:on-success="handleVideoSuccess"
            v-bind:before-upload="beforeUploadVideo"
            v-bind:show-file-list="false">
              <div><el-button size="small">浏览...</el-button></div>
              <video v-show="saveData.video_path !='' && !videoFlag"
                     v-bind:src="saveData.video_path"
                     class="avatar video-avatar"
                     controls="controls"
                     style="margin-top: 10px; width: 120px">
                  您的浏览器不支持视频播放
              </video>
              <el-progress v-if="videoFlag == true"
                           type="circle"
                           v-bind:percentage="videoUploadPercent"
                           style="margin-top:7px;"></el-progress>
          </el-upload>
          <div style="color: red;">上传视频不能超过100M,格式：mp4,(512≤码率≤2048)kbps</div>
        </el-form-item>
        <el-form-item label="上传素材" required v-show="saveData.adv_type !== '8'">
          <el-upload action="" ref="upload" class="avatar-uploader" :show-file-list="false" :on-change="logoUpload">
            <el-button size="small">浏览...</el-button>
            <img v-if="saveData.pic" :src="getImage(saveData.pic)" class="avatar" style="margin-top: 10px; width: 100%;">
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveLink">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      form: {
        source_id: 2,
        keyword: '',
      },
      videoFlag: false,
      videoUploadPercent: '',
      saveData: {
        material_id: 0,
        source_id: 2,
        is_edit: 0,
        network: "0",
        carrier: "0",
        adv_type: "1",
        material_name: "",
        material_desc: "",
        link_type: "1",
        link_id: 0,
        down_link: "",
        suffix: '',
        pic: "",
        video_path: "",
      },
      dialogVisible: false,
      page: 1,
      checked: 1,
      old_input: '',
      old_title: '',
      input: '',
      title: '',
      plan_id: 0,
      pageSize: 10,
      pageTotal: 1,
      tableData: [],
      company_name: '',
      linkData: [],
    };
  },
  mounted() {
    this.company_name = JSON.parse(sessionStorage.getItem('user_info'))['company_name'];
    this.getData();
    this.getLinkData();
  },
  methods: {
    getAdvType(adv_type) {
      return {
        1: "小图",
        2: "大图",
        3: "组图",
        4: "横幅",
        5: "插屏",
        6: "开屏",
        7: "视频暂停位",
        8: "视频广告位",
      }[adv_type]
    },
    getNetwork(row) {
      return {
        carrier: ['不限', '中国移动', '中国联通', '中国电信'][row.carrier],
        network: ['不限', '2G', '3G', '4G', '5G', 'WIFI'][row.network]
      }
    },
    getLinkData() {
      this.$http.post('/trader/link/getLinkLists', { pageSize: 10000 }).then(res => {
        if (res.code === 200) {
          this.linkData = res.data
          this.$function.hiddenLoading();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getLink() {
      return this.$Config.apiUrl + '/trader/plan/fileUpload';
    },
    getImage(logo) {
      return logo.includes('base64,') ? logo : this.$Config.apiUrl + logo;
    },
    logoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
      //  this.$message.error('图片大小不能超过 2MB');
      //  return;
      }
      if (file.raw.type.includes('gif')) {
        this.$message.error('图片格式不能是GIF');
        return;
      }

      this.$function.blobToDataURL(file.raw, res => {
        const imgType = file.raw.type.split('/');
        this.saveData.suffix = imgType[1];
        this.saveData.pic = res;
      });
    },
    // 上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 100;
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
        this.$message.error('请上传正确的视频格式');
        return false;
      }
      if (!fileSize) {
        this.$message.error('视频大小不能超过100MB');
        return false;
      }
      this.isShowUploadVideo = false;
    },
    // 进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    // 上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      // 后台上传地址
      if (res.code === 200) {
        this.saveData.video_path = res.path;
      } else {
        this.$message.error(res.msg);
      }
    },
    saveLink() {
      this.$http.post('/trader/material/createMaterial', this.saveData).then(res => {
        if (res.code === 200) {
          this.getData();
          this.dialogVisible = false;
          this.$function.hiddenLoading();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    editLink() {
      this.$http.post('/trader/link/savePlan', this.editData).then(res => {
        if (res.code === 200) {
          this.getData();
          this.dialogVisible2 = false;
          this.$function.hiddenLoading();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getData() {
      this.$http.post('/trader/material/getMaterialLists', {
        keyword: this.form.keyword,
        source_id: this.saveData.source_id,
        page: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    },
    search() {
      this.tableData = [];
      this.page = 1;
      this.getData();
    },
    addPlan() {
      this.saveData.is_edit = 0;
      this.dialogVisible = true;
    },
    editOne(index) {
      const item = this.tableData[index];
      this.saveData = {
        material_id: item.material_id,
        source_id: 2,
        is_edit: 1,
        network: item.network + '',
        carrier: item.carrier + '',
        adv_type: item.adv_type + '',
        material_name: item.material_name,
        material_desc: item.material_desc,
        link_type: item.link_type + '',
        link_id: Number(item.link_id),
        down_link: item.down_link,
        suffix: item.suffix,
        pic: item.pic,
        video_path: item.video_path,
      },
      this.dialogVisible = true;
    },
    delOne(material_id) {
      if (material_id > 0) {
        this.$http.post('/trader/material/del', {
          material_id
        }).then(res => {
          if (res.code === 200) {
            this.getData();
          }
        });
      }
    },
  },
  watch: {

  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    line-height: 54px;
    color: #333;
    padding-left: 22px;
  }
  .body {
    width: calc(100% - 69px);
    margin-left: 23px;
    width: 1400px;
    .condition {
      margin-top: 20px;
      width: 1400px;
      height: 55px;
      .form {
        float: left;
        width: 950px;
      }
      .other {
        float: right;
        width: 440px;
      }
      .demo-input-suffix {
        display: inline-block;
        font-size: 14px;
        color: #999;
        margin-right: 31px;
      }
    }
    .page-c {
      margin-top: 20px;
      text-align: right;
      margin-right: 30px;
    }
  }

</style>
